import { useOnce } from '../use-once';
import { useSharedValueStoreContext } from './context';
function runEffects(values, effects) {
    effects.forEach(function (effect) { return effect(values); });
}
export function useSharedValueEffects(effects) {
    var values = useSharedValueStoreContext();
    useOnce(function () { return runEffects(values, effects); });
}
//# sourceMappingURL=shared-value-effects.js.map